module.exports = __webpack_public_path__ + "img/RR Full.cfd19116.png";